


(() => {
const filterNodes = {
  container: document.getElementById('collection-container') || document.getElementById('search-container'),
  parent: document.getElementById('storefront-filters-parent'),
  collectionBanner: document.querySelector('[data-collectionBanner]'),
  quickShopModal: document.querySelector('quick-shop'),
}

class storefrontFilters {
  constructor() {
    // console.log('filterNodes.container===>', filterNodes.container, filterNodes.parent);
    if(!filterNodes.container || !filterNodes.parent) return;

    this.form = filterNodes.container.querySelector('#storefront-filters-form');
    this.gridsContainer = filterNodes.container.querySelector('#products-listing');
    this.paginate = filterNodes.container.querySelector('[data-paginationParent]');
    this.activeFilters = filterNodes.container.querySelector('[data-activeFilters]');
    this.drawer = filterNodes.parent.querySelector('#storefront-filter-drawer');
    this.drawerFooter = filterNodes.parent.querySelector('[data-filterFooter]'),

    this.debouncedOnSubmit = Utility.debounce((event) => this.onSubmitHandler(event), 1000);

    if (this.form) {
      this.form.addEventListener('input', (evt) => {
        const element = evt.target || evt.currentTarget;
        if (element.type === 'range' || (element.nodeName !== 'FORM' && element.name != 'sort_by' && window.innerWidth < 992)) return;
        this.debouncedOnSubmit(evt);
      });
      this.form.addEventListener('submit', this.debouncedOnSubmit.bind(this));
    }

    this.manageDrawerUI(window.innerWidth);
    this.bindEvents();
    this.dynamicEleEvents();
  }

  handleHideShowDrawerToggle() {
    const toggleButton = document.querySelector('[data-hideShowFilterDrawer]');
    const filtersParent = filterNodes.parent;
    const sidebarProductGrid = document.querySelector('#sidebar-product-grid');
  
    if (toggleButton && filtersParent) { 
      // Define and attach a new handler
      toggleButton._filterToggleHandler = () => {
        const isOpen = toggleButton.classList.contains('open');
  
        if (isOpen) {
          // Close filter
          toggleButton.classList.remove('open');
          toggleButton.classList.add('close');
          filtersParent.classList.remove('open');
          filtersParent.classList.add('close');
          sidebarProductGrid.classList.remove('sidebar-product-grid-open');
        } else {
          // Open filter
          toggleButton.classList.remove('close');
          toggleButton.classList.add('open');
          filtersParent.classList.remove('close');
          filtersParent.classList.add('open');
          sidebarProductGrid.classList.add('sidebar-product-grid-open');
        }
      };
  
      toggleButton.addEventListener('click', toggleButton._filterToggleHandler);
    }
  }

  /**
   * Switch between Drawer/Colume view
  */
  manageDrawerUI(windowWidth){
    let filterGrid = filterNodes.parent.querySelector('#storefront-filter-grid');
    const elementToClone = filterGrid;

    filterGrid.remove();

    if(windowWidth >= 992){
      this.drawer.parentNode.appendChild(elementToClone);
      // this.drawer.closeDrawer();
    }else{
      this.drawer.querySelector('div.drawer-body').appendChild(elementToClone);
    }
    filterGrid = elementToClone;
  }

  /**
   * bind events to UI element events
  */
  bindEvents() {
    window.onresize = () => {
      this.manageDrawerUI(window.innerWidth);
    };
    const sortbyDesktop = filterNodes.container.querySelectorAll('#sortby-dropdown .sortby_options');
    sortbyDesktop.forEach(input => input.addEventListener('change', this.updateSortBy.bind(this)));

    const loadMoreBtn = document.querySelector('[data-loadmore]');
    if(loadMoreBtn && !loadMoreBtn._loadMoreObserver) this.infiniteLoad(loadMoreBtn);


    const closeFilters = filterNodes.parent.querySelectorAll('[data-closefilter]');
    closeFilters.forEach(btn => { 
      btn.addEventListener('click', (evt)=>{
        evt.preventDefault();
        let drawer = evt.currentTarget.closest('custom-drawer');
        if(drawer){
          // Close the drawer
          const closeDrawerButton = drawer.querySelector('[data-closedrawer]');
          closeDrawerButton?.click();

          // Find the open collapsible panel and toggle it
          const openPanel = drawer.querySelector('[is="collapsiblePanel"].open');
          const toggleButton = openPanel?.querySelector('[data-toggle="panel"]');
          toggleButton?.click();
        }
      });
    });
    const backFilters = filterNodes.parent.querySelectorAll('[data-back]');
    backFilters.forEach(btn => { 
      btn.addEventListener('click', (evt)=>{
        evt.preventDefault();
        let panel = evt.currentTarget.closest('[is="collapsiblePanel"]');
        panel?.querySelector('[data-toggle="panel"]')?.click();
      });
    });

    this.handleHideShowDrawerToggle();
  }

  dynamicEleEvents() {

    if (filterNodes.quickShopModal?.updateEvents) filterNodes.quickShopModal.updateEvents();

    const applyBtn = filterNodes.parent.querySelector('[data-applyFilters]');
    applyBtn?.addEventListener('click', () => {
      const searchParams = this._createQueryString(this.form)
      this.renderPage(searchParams);
    });

    const paginationLinks = filterNodes.container.querySelectorAll('[data-pagelinks], [data-loadmore]');
    paginationLinks.forEach(link => link.addEventListener('click', this._managePagination.bind(this)));

    const loadMoreBtn = document.querySelector('[data-loadmore]');
    if(loadMoreBtn && !loadMoreBtn._loadMoreObserver) this.infiniteLoad(loadMoreBtn);


    
    this.colorOptionsStyling();
    this.bindActiveFilterButtonEvents();
  }

  /**
   * Filter form submit event
   */
  onSubmitHandler(event) {
    event.preventDefault();

    if(event.type == 'input' && filterNodes.parent.classList.contains('filter-active')){
      /******** enable clicking fitlers suddenly **********/
      filterNodes.parent.classList.remove('loading');
      return;
    }

    const searchParams = this._createQueryString(this.form)
    this.renderPage(searchParams);
  }

  /**
   * click event To Remove current selections
   * @param {element} form Collection page filter form
   */
  _createQueryString(form){
    const formData = new FormData(form);
    const priceGTE = form.querySelector('[name="filter.v.price.gte"]');
    const priceLTE = form.querySelector('[name="filter.v.price.lte"]');

    if (priceGTE && priceGTE.min === formData.get('filter.v.price.gte')) {
      formData.delete('filter.v.price.gte');
    }
    if (priceLTE && priceLTE.max === formData.get('filter.v.price.lte')) {
      formData.delete('filter.v.price.lte');
    }
    return new URLSearchParams(Array.from(formData)).toString();
  }

  /**
   * 
   * @param {String} searchParams Query Parameters
   * @param {Boolean} updateURLHash true/false
  */
  async renderPage(searchParams, updateURLHash = true) {
    this.gridsContainer.classList.add('loading');

    const url = `${window.location.pathname}?${searchParams}`;
    await this.renderGridFromFetch(url, 'filter');

    if (updateURLHash) this.updateURLHash(searchParams);
  }

  /**
   * Add background color in label of Color options
   */
  colorOptionsStyling(){
    const colorSwatchContainer = filterNodes.parent.querySelector('[data-colorFilter]');
    if(!colorSwatchContainer) return;

    colorSwatchContainer.querySelectorAll('.color-options').forEach(swatch => {
      const colorHandle = swatch.querySelector('input[type="checkbox"]').dataset.handle;
      const swatchStyle = Utility.getSwatchStyle(colorHandle);
      swatch.querySelector('.option-label').setAttribute('style', swatchStyle);
    });
  }

  /**
   * Remove active filters
   */
   onActiveFilterClick(event) {
    event.preventDefault();
    event.stopImmediatePropagation();

    const URLString = new URL(event.currentTarget.href).searchParams.toString();
    if(URLString != null) this.renderPage(URLString);
  }

   /**
   * Update Window URL
   */
  onHistoryChange(event) {
    const searchParams = event.state?.searchParams || '';
    this.renderPage(searchParams, false);
  }

  /**
   * 
   * @param {String} url URL for fetching results
   * @param {String} type filter / pagination
   */
  async renderGridFromFetch(url, type) {
    if(!url) return;

    const sectionID = filterNodes.container.dataset.section;
    url += `&sections=${sectionID}`;

    try {
      const response = await fetch(url);
      const data = await response.json();
      const gridHTML = data[sectionID];
      this.renderProductGrid(type, gridHTML);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  }

  /**
   * 
   * @param {HTMlResponse} html 
   * @param {String} type filter / pagination
   */
  renderProductGrid(type, grid) {
    const html = new DOMParser().parseFromString(grid, 'text/html');
    const filterPanels = html.querySelectorAll('#storefront-filters-form .individual-filter-block');

    const paginationType = this.paginate?.dataset.type || 'numbers';
    
    const productGrids = this.gridsContainer.querySelector('[data-products-grid');
    const loadMoreBtn = this.gridsContainer.querySelector('[data-loadmore]');
    const totalProductsElement = filterNodes.container.querySelectorAll('[data-totalProducts]');
    const activeFilterCountElement = document.querySelectorAll('[data-activeFilterCount]');
    const showMore = this.gridsContainer.querySelector('[data-showmore-text]');

    if (type === 'pagination' && paginationType === 'loadmore') {
        productGrids.insertAdjacentHTML('beforeend', html.querySelector('[data-products-grid]').innerHTML);

        const newLoadMoreBtn = html.querySelector('[data-loadmore]');
        const newShowMore = html.querySelector('[data-showmore-text]');
        if (newLoadMoreBtn && loadMoreBtn) {
            loadMoreBtn.parentNode.replaceChild(newLoadMoreBtn, loadMoreBtn);
            showMore?.parentNode.replaceChild(newShowMore, showMore);
            this.infiniteLoad(newLoadMoreBtn);
        } else if (loadMoreBtn) {
            loadMoreBtn.remove();
            showMore.remove();
        }
    } else {
      this.gridsContainer.innerHTML = html.querySelector('#products-listing').innerHTML;
    }
    lazyImageObserver.observe();
    
    // Manage filter panels display
    let filterBlocks = document.querySelectorAll('#storefront-filters-form .individual-filter-block');
    filterBlocks.forEach(panel => panel.classList.add('d-none'));

    filterPanels.forEach(panel => {
      const filterBlock = document.querySelector(`.individual-filter-block[data-index="${panel.dataset.index}"]`);
      if (filterBlock) {
          filterBlock.querySelector('.filter__block').innerHTML = panel.querySelector('.filter__block').innerHTML;
          filterBlock.classList.remove('d-none');
      }
    });

    if (totalProductsElement) { // Update total products count
      totalProductsElement.forEach(element => {
        element.innerHTML = html.querySelector('[data-totalProducts]').innerHTML;
      });
    }

    if (activeFilterCountElement) {
      activeFilterCountElement.forEach(element => {
        element.innerHTML = html.querySelector('[data-activeFilterCount]').innerHTML;
      });
    }

    this.drawerFooter.innerHTML = html.querySelector('[data-filterFooter]').innerHTML; // Update drawer footer

    const activeFilters = html.querySelector('[data-activeFilters]'); // Update active filters
    if (activeFilters) {
      this.activeFilters.innerHTML = activeFilters.innerHTML;
    }

    this.dynamicEleEvents();
    if (this.drawer?.isOpen) this.drawer.closeDrawer(); // Close drawer if open
  }

  /**
   * Re-Binding events on active filters after ajax request
   */
  bindActiveFilterButtonEvents() {
    const removeActiveFilters = Array.from(document.getElementsByClassName('filter-option-clear'));
    removeActiveFilters.forEach((element) => {
      element.addEventListener('click', this.onActiveFilterClick.bind(this), { once: true });
    });

    // Manage shape filter active state
    const activeShapeFilters = this.form?.querySelectorAll('input[name="filter.p.m.filter.shape"]:checked') || [];
    const shapeFilters = document.querySelectorAll('[data-shape-filter]');
    shapeFilters.forEach((shapeFilter) => {
      shapeFilter.closest('.shape-filter-item').classList.remove('active');
    });
    activeShapeFilters.forEach((filter) => {
      const shapeFilter = document.querySelector(`[data-shape-filter][data-shape-handle="${filter.value}"]`);
      if(shapeFilter) shapeFilter.closest('.shape-filter-item').classList.add('active');
    });
  }

  /**
   * Update the url
   * @param {String} searchParams 
   */
  updateURLHash(searchParams) {
    window.history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  updateSortBy(event){
    const currentEle = event.currentTarget;
    const sortByInput = this.form.querySelector('input[name="sort_by"]');
    sortByInput.value = currentEle.value;

    this.form.dispatchEvent(new Event('input', { once: true }));
  }

  async _managePagination(event){
    event.preventDefault();
    const _this = event.currentTarget;
    await this.renderGridFromFetch(_this.href, 'pagination');

    const paginationType = this.paginate?.dataset.type || 'numbers';
    if(paginationType != 'loadmore'){
      setTimeout(() => {
        window.history.pushState({}, '', _this.href);
      }, 500);
    }
  }

  infiniteLoad(loadMoreBtn){
    if(!loadMoreBtn) return;

    // Disconnect any existing observer for this button
    if (loadMoreBtn._loadMoreObserver) {
      loadMoreBtn._loadMoreObserver.disconnect();
      loadMoreBtn._loadMoreObserver = null;
    }

    // Create new observer and store reference on the button
    loadMoreBtn._loadMoreObserver = new IntersectionObserver((entries, observer) => { 
      entries.forEach(entry => {
        if(entry.isIntersecting) {
          loadMoreBtn.click();
          observer.disconnect();
          loadMoreBtn._loadMoreObserver = null;
        }
      });
    }, {
      rootMargin: '800px'
    });
    
    loadMoreBtn._loadMoreObserver.observe(loadMoreBtn);
  }
}
if (typeof storefrontFilters !== 'undefined') new storefrontFilters();
})();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    
    this.querySelectorAll('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));

    this.setMinAndMaxValues();
    this.manageSliderChange();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input[name="filter.v.price.gte"], input[name="filter.v.price.lte"]');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  // eslint-disable-next-line class-methods-use-this
  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }

  // eslint-disable-next-line class-methods-use-this
  manageSliderChange() {
    const sliderSection = this.querySelector("#range-slider");
    const sliders = sliderSection.getElementsByTagName("input");
    Array.from(sliders).forEach(slider => {
      slider.oninput = () => {
        let slide1 = Number(sliders[0].value);
        let slide2 = Number(sliders[1].value);

        // Neither slider will clip the other, so make sure we determine which is larger
        if( slide1 > slide2 ){ const tmp = slide2; slide2 = slide1; slide1 = tmp; }
        this.querySelector('input[name="filter.v.price.gte"]').value = slide1;
        this.querySelector('input[name="filter.v.price.lte"]').value = slide2;
      }
      slider.onchange = () =>{
        if(window.innerWidth >= 992) this.closest('form').dispatchEvent(new CustomEvent('submit'));
      }
    });
  }
}
customElements.define('price-range', PriceRange);

